import { isAdmin, isPartner } from '../../../helpers/appType';
import { useAuth } from '../../../store/auth';
import { UserRole } from '../../../types/user.types';

/**
 * Who has a bell in this app.
 *
 * The list is per user, so anyone could be asked for one - but marketing and
 * the merchant's staff are sent nothing, and a bell that never rings is just
 * furniture. Internal notifications go to admin and support; the merchant ones
 * to the owner, and to a manager for whatever was addressed to them.
 */
const ROLES_WITH_BELL: readonly UserRole[] = isAdmin
  ? [UserRole.admin, UserRole.support]
  : isPartner
  ? [UserRole.partner, UserRole.manager]
  : [];

/**
 * The signed-in user as the bell needs them: their id, which every cache key
 * carries, and whether they get a bell at all. `userId` is 0 while signed out,
 * and `enabled` false.
 */
export const useNotificationsViewer = () => {
  const userId = useAuth((state) => state.user?.id) ?? 0;
  const role = useAuth((state) => state.user?.role) as UserRole | undefined;

  return {
    userId,
    role,
    enabled: !!userId && !!role && ROLES_WITH_BELL.includes(role),
  };
};
